<template>
  <div
    class="ui-copy-button"
    @click="copyText"
  >
    <ui-icon
      v-if="!copyValueSuccess"
      :size="iconSize"
      :type="iconType"
      name="uiCopy"
    />
    <ui-icon
      v-else
      :size="iconSize"
      type="success"
      name="uiCheck"
    />
    <slot />
  </div>
</template>

<script>
import UiIcon from './icons/UiIcon.vue'

import { writeClipboardText } from '../libs/helpTools'

export default {
  components: { UiIcon },
  props: {
    iconSize: {
      type: Number,
      default: 24
    },
    iconType: {
      type: String,
      default: 'primary'
    },
    text: String
  },
  data () {
    return {
      copyValueSuccess: false,
      copyValueLoading: false
    }
  },
  methods: {
    async copyText () {
      if (this.copyValueLoading) return
      try {
        this.copyValueLoading = true
        await writeClipboardText(this.text)
        this.$emit('copy', this.text)
        this.copyValueSuccess = true
        setTimeout(() => { this.copyValueSuccess = false }, 1500)
      } finally {
        this.copyValueLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-copy-button {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;
}
</style>
